import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/offline-product-sales';

const stripEmpty = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== '' && v !== null && v !== undefined),
  );

const unwrap = (response) => response.data?.data ?? response.data;

const offlineProductSalesService = {
  list: async (params = {}) => {
    const response = await apiClient.get(BASE, {
      params: stripEmpty({ page: 1, limit: 20, ...params }),
    });
    const data = unwrap(response);
    return {
      items: Array.isArray(data?.items) ? data.items : [],
      pagination: data?.pagination ?? { page: 1, limit: 20, total: 0, total_pages: 0 },
    };
  },

  getProductTypes: async () => {
    const response = await apiClient.get(`${BASE}/meta/product-types`);
    const data = unwrap(response);
    return Array.isArray(data?.product_types) ? data.product_types : [];
  },

  calculate: async (payload) => {
    const response = await apiClient.post(`${BASE}/calculate`, payload);
    return unwrap(response);
  },

  getByUuid: async (uuid) => {
    const response = await apiClient.get(`${BASE}/${uuid}`);
    const data = unwrap(response);
    return data?.record ?? data;
  },

  create: async (payload) => {
    const response = await apiClient.post(BASE, payload);
    const data = unwrap(response);
    return data?.record ?? data;
  },

  update: async (uuid, payload) => {
    const response = await apiClient.patch(`${BASE}/${uuid}`, payload);
    const data = unwrap(response);
    return data?.record ?? data;
  },

  delete: async (uuid) => {
    const response = await apiClient.delete(`${BASE}/${uuid}`);
    return response.data;
  },
};

export default offlineProductSalesService;
